import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
    state: () => ({
        userId: null,
        userRole: null,
        listUsers: [],
        listProjects: [],
        isAppStarted: false,
        isLoading: false,
        domain: 'https://tree-web.ru',
        baseApi: '/tgtask/api',
        userNoPhotoImg: 'img/user-no-photo.jpg',
        lastPath: '#/tasks',
        headMenu: {
            tasks: {
                sort: [
                    {
                        name: 'Недавняя активность',
                        by: 'DATE_UPDATE',
                        order: 'DESC',
                        selected: false
                    },
                    {
                        name: 'Сначала новые',
                        by: 'DATE_CREATE',
                        order: 'DESC',
                        selected: false
                    },
                    {
                        name: 'Новые в конце',
                        by: 'DATE_CREATE',
                        order: 'ASC',
                        selected: false
                    },
                    {
                        name: 'По статусу',
                        by: 'STATUS_ID',
                        order: 'ASC',
                        selected: false
                    }
                ],
                filter: [
                    {
                        name: 'Все',
                        field: '',
                        value: '',
                        selected: false
                    },
                    {
                        name: 'Я ответственный',
                        field: 'RESPONSIBLE_ID',
                        value: "Y",
                        selected: false
                    },
                    {
                        name: 'Новые',
                        field: 'STATUS_ID',
                        value: 1,
                        selected: false
                    },
                    {
                        name: 'Выполняются',
                        field: 'STATUS_ID',
                        value: 2,
                        selected: false
                    },
                    {
                        name: 'Завершены',
                        field: 'STATUS_ID',
                        value: 4,
                        selected: false
                    },
                    {
                        name: 'Требуют внимания',
                        field: 'REQUIRE_ATTENTION',
                        value: "Y",
                        selected: false
                    }
                ]
            }
        },
        tasksSort: {
            by: 'DATE_UPDATE',
            order: 'DESC'
        },
        tasksFilter: {
            field: '',
            value: ''
        },
        currentTaskTitle: ''
    }),
    actions: {
        getBackRoute(currentRoute) {
            const routeMap = {
                '/tasks/add': '/tasks',
                '/tasks/:id': '/tasks',
                '/tasks/:id/edit': '/tasks/:id',
                '/tasks/:id/comments': '/tasks/:id',
                '/projects/add': '/projects',
                '/projects/:id': '/projects',
                '/projects/:id/edit': '/projects/:id'
            };

            // Заменяем динамические параметры на шаблоны
            const path = currentRoute.path
                .replace(/\/\d+/g, '/:id')
                .replace(/\/edit$/, '');

            return routeMap[path] || '/';
        },
        renewListUsers(context) {
            const $this = this
            this.listUsers = []

            return context.postToServer('users/getAll', {}, function (resp) {
                if (resp.data.result !== undefined) {
                    $this.listUsers = resp.data.result
                }

                return resp;
            });
        },
        setAppStarted() {
            var $this = this;

            setTimeout(function () {$this.isAppStarted = true;}, 1000);
        },
        startLoading() {
            this.isLoading = true;
        },
        stopLoading() {
            this.isLoading = false;
        },
        setLastPath(path) {
            this.lastPath = path;
        },
        setSort(index, page) {
            this.tasksSort.by = this.headMenu[page].sort[index].by;
            this.tasksSort.order = this.headMenu[page].sort[index].order;
            this.headMenu[page].sort = this.headMenu[page].sort.map((option, i) => {
                return {
                    ...option,
                    selected: index === i
                };
            });
        },
        setFilter(index, page) {
            this.tasksFilter.field = this.headMenu[page].filter[index].field;
            this.tasksFilter.value = this.headMenu[page].filter[index].value;
            this.headMenu[page].filter = this.headMenu[page].filter.map((option, i) => {
                return {
                    ...option,
                    selected: index === i
                };
            });
        },
        getFilter() {
            return this.tasksFilter;
        },
        getSort() {
            return this.tasksSort;
        }
    }
})